import {createSvgIcon} from '../create-svg-icon';

export const CallMissedIcon = createSvgIcon(
  <path d="M19.59 7 12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z" />
, 'CallMissedOutlined');
